/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Quick Schedule review step styles
 *
 * @file QuickScheduleReviewStepStyles.js
 * @author Anuja Gaikwad
 * @since 2.0.3
 */

import { styled } from '@mui/material/styles';
import mixins from '../../../assets/styles/mixins.scss';
import CommonStyles from '../../../assets/styles/CommonStyles';
import { createScopedClasses, createScopedStyles } from '../../../assets/styles/createScopedStyles';

export const QUICK_SCHEDULE_PANEL_HEIGHT = 560;

const scrollStyles = CommonStyles().scrollContainer({
  scrollbarWidth: 4,
  scrollbarColor: '#e8e6f3 transparent',
  borderRadius: 8
});

const QuickScheduleReviewStepStyles = () => ({
  reviewPane: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  contentLayout: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    width: '100%',
    alignItems: 'stretch',

    [mixins['md-sm-min']]: {
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)'
    }
  },
  contentTreePane: {
    backgroundColor: mixins.chalkWhiteFont,
    borderRadius: 16,
    padding: 24,
    boxSizing: 'border-box',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    height: QUICK_SCHEDULE_PANEL_HEIGHT,
    overflow: 'hidden',

    [mixins['md-sm-min']]: {
      height: QUICK_SCHEDULE_PANEL_HEIGHT
    },

    [mixins['ml-max']]: {
      padding: 16
    }
  },
  schedulePane: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    height: QUICK_SCHEDULE_PANEL_HEIGHT,
    overflow: 'hidden'
  },
  scheduleScroll: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    ...scrollStyles
  }
});

export const classes = createScopedClasses(
  'aet-quick-schedule-review-step',
  QuickScheduleReviewStepStyles()
);

export const scopedStyles = createScopedStyles(QuickScheduleReviewStepStyles(), classes);

export const QuickScheduleReviewStepStylesRoot = styled('div')(scopedStyles);

export default QuickScheduleReviewStepStyles;
